import { Analytics, type Environment } from '@1debit/analytics';

// Environment values expected by the SDK: development, dev1-dev5, qa, production
const appEnvironment = (process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT || 'development') as Environment;

export const analyticsHandler = new Analytics({
	env: appEnvironment,
	applicationName: 'chimecloud-client',
	variant: 'onlyEventRouter',
});
